import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  INewOwnerDetailModel,
  INewOwnerDetailUpdateModel,
} from '../../models/NewOwners'

const initialState = {
  data: null as INewOwnerDetailModel | null,
  updateStatus: null as INewOwnerDetailUpdateModel | null,
  error: null,
  loading: false,
}

const newOwnerDetailSlice = createSlice({
  name: 'newOwnersDetails',
  initialState,
  reducers: {
    fetchDetailsRequest: (state, _: PayloadAction<string>) => {
      state.loading = true
    },
    fetchDetailsSuccess: (
      state,
      action: PayloadAction<INewOwnerDetailModel>
    ) => {
      state.loading = false
      state.data = action.payload
      state.error = null
    },
    fetchDetailsError: (state, action) => {
      state.loading = false
      state.error = action.payload
    },

    updateStatusRequest: (
      state,
      action: PayloadAction<INewOwnerDetailUpdateModel>
    ) => {
      state.loading = true
      state.updateStatus = action.payload
    },
    updateStatusSuccess: (state) => {
      state.loading = false
    },

    updateStatusError: (state, action) => {
      state.loading = false
      state.updateStatus = null
      state.error = action.payload
    },
  },
})

export default newOwnerDetailSlice
